export interface AppserverUnauthenticatedCredentials {
    forsyningId: string;
    brugerNavn: string;
    kodeordKrypteret: string;
}
